import * as React from "react";

const SvgIconArrowDown = (props) => {
  return (
    <svg width={30} height={30} viewBox="0 0 7.938 7.938" {...props}>
      <g fill="none">
        <g stroke="#6e7f86" strokeLinecap="round" strokeWidth={0.886}>
          <path
            d="M3.969 2.103v3.734M5.257 4.549L3.97 5.838M2.68 4.549l1.289 1.289"
            strokeWidth={0.64401568}
          />
        </g>
        <path d="M0 0h7.938v7.938H0z" />
      </g>
    </svg>
  );
};

export default SvgIconArrowDown;
